import { cn } from "@/lib/utils"

// Shared styling for the pill-shaped filter dropdown triggers on the Pipeline
// view. When a filter is `active`, the trigger picks up the
// accent color so it reads as "this list is filtered" at a glance.
export function filterTriggerClasses(active: boolean) {
  return cn(
    "inline-flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-sm transition-colors",
    active
      ? "border-accent bg-accent-faded text-accent-display"
      : "border-hairline bg-page text-ink-body hover:bg-surface",
  )
}
